const page_500 = {
	description:
		"Entschuldigung, auf unserer Seite ist etwas schief gelaufen. Bitte versuchen Sie es später noch einmal.",
	home_button: "Zur Homepage gehen",
	return_button: "Erneut versuchen",
	title: "500 Error",
};

export default page_500;
